// import {RouterProvider, createHashRouter} from "react-router-dom";
import "./App.css";
// import { AppContext } from "./components/index";
// import React,{useState} from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/core/home/Home';
import About from './pages/core/about/About';
import Contact from './pages/core/contact/Contact';
import ChannelPartners from './pages/core/channelPartners/ChannelPartners';
import Catelogs from './pages/core/catelogs/Catelogs';
import Download from './pages/core/download/Download';
import Project from './pages/core/project/Project';
import ProjectDetails from './pages/core/project/ProjectDetails';
import Product from './pages/core/products/Product';
import ProductDetails from './pages/core/products/ProductDetails';
import Login from './pages/core/login/Login';
import AdminUploadPage from "./pages/core/AdminUploadPage/AdminUploadPage"

function App() {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/channelPartners" element={<ChannelPartners />} />
        <Route path="/Catelogs" element={<Catelogs />} />
        <Route path="/Download" element={<Download />} />
        <Route path="/Project" element={<Project />} />
        <Route path="/ProjectDetails/:id" element={<ProjectDetails />} />
        <Route path="/product/:id" element={<Product />} />
        <Route path="/productDetails" element={<ProductDetails />} />
        <Route path="/login" element={<Login />} />
        <Route path="/upload" element={<AdminUploadPage />} />
      </Routes>
    </Router>
  );
}
// const router = createHashRouter([
//   {
//     element: <Home />,
//     path: "/",
//     shouldRevalidate: () => false,
//   },
//   {
//     element: <About />,
//     path: "/about",
//     shouldRevalidate: () => false,
//   },
//   {
//     element: <Contact />,
//     path: "/contact",
//     shouldRevalidate: () => false,
//   },
//   {
//     element: <ChannelPartners />,
//     path: "/channelPartners",
//     shouldRevalidate: () => false,
//   },
//   {
//     element: <Catelogs />,
//     path: "/Catelogs",
//     shouldRevalidate: () => false,
//   },
//   {
//     element: <Download />,
//     path: "/Download",
//     shouldRevalidate: () => false,
//   },
//   {
//     element: <Project />,
//     path: "/Project",
//     shouldRevalidate: () => false,
//   },
//   {
//     element: <ProjectDetails />,
//     path: "/ProjectDetails/:id",
//     shouldRevalidate: () => false,
//   },
//   {
//     element: <Product />,
//     path: "/product/:id",
//     shouldRevalidate: () => false,
//   },
//   {
//     element: <ProductDetails />,
//     path: "/productDetails",
//     shouldRevalidate: () => false,
//   }
// ]);
//   const App = () => {
//     const [loading, setLoading] = useState(false);
//     const [userData, setUserData] = useState({
//       userName: "",
//       userRoles: "",
//     });
//     const handleLoading = (item) => {
//       setLoading(item);
//     };
//     const handleUserData = (data) => {
//       if (data.hasOwnProperty("userName") && data.hasOwnProperty("userRoles")) {
//         setUserData(data);
//       } else if (data.hasOwnProperty("userName")) {
//         let obj = {
//           userName: data.userName,
//           userRoles: userData.userRoles,
//         };
//         setUserData(obj);
//       } else if (data.hasOwnProperty("userRoles")) {
//         let obj = {
//           userName: userData.userName,
//           userRoles: data.userRoles,
//         };
//         setUserData(obj);
//       }
//     };
//     const commonLoading = {
//       loading: loading,
//       userData: userData,
//       handleLoading,
//       handleUserData,
//     };
// return (
//   // <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
//     <AppContext.Provider value={commonLoading}>
//       <RouterProvider router={router} />
//     </AppContext.Provider>
//   // </Sentry.ErrorBoundary> 
// );
// };

export default App;
